import React, { useContext, useEffect, useRef, useState } from "react";
import "./index.css"
import styles from "./Winner.module.css"
import blue from "../../../assets/blue.png"
import { NAME_SERVER } from "../../../Utils/NAME_HOST";
import formatCurrency from "../../../Utils/formatCurrency";
import Sound_play from "../../../Utils/sound_play";
import { sound_winGAME } from "../../../Utils/sounds";
import { Context } from "../../..";

function Winner(props) {
    const balance = props.balance;
    const {store} = useContext(Context)
    const color = balance>0||balance===null?"greenyellow":"red"
    

    useEffect(() => {
        
        if (props.choice_bil === "demo") {
            props.setDemo_balance(props.demo_balance + balance)
        }
        
    }, []);

    return (
        <div className={styles.containerCircle}>
            <div className={styles.circle} style={{borderColor:color}}>
            <div className={styles.text}>Выжил</div>

            {balance>0&&<div className={styles.text} style={{color}}>+{formatCurrency(Number(balance,"cost"))}</div>}
            <img src={NAME_SERVER + "/assets/" + props.color + ".png"}/>
            <div className={styles.text}>#{props.name}</div>
</div>
        </div>
        
        // <article>
        //     <div>
        //         <svg
        //             version="1.1"
        //             xmlns="http://www.w3.org/2000/svg"
        //             xmlnsXlink="http://www.w3.org/1999/xlink"
        //             x="0px"
        //             y="0px"
        //             width="300px"
        //             height="50.5em"
        //             viewBox="0 0 200 200"
        //             xmlSpace="preserve"
        //             className="svg-loader"

        //         >
        //             <defs>
        //                 {/* SVG GLOW FILTER */}
        //                 <filter id="glow" x="-120%" y="-120%" width="400%" height="400%">
        //                     <feOffset result="offOut" in="SourceGraphic" dx="0" dy="0"></feOffset>
        //                     <feGaussianBlur result="blurOut" in="offOut" stdDeviation="10"></feGaussianBlur>
        //                     <feBlend in="SourceGraphic" in2="blurOut" mode="overlay"></feBlend>
        //                 </filter>
        //             </defs>
        //             <g>
        //                 {/* Gray circle under the second countdown circle */}
        //                 <circle fill="none" cx="6.25em" cy="6.25em" r="5em" className="winner" transform="scale(.8, .8) translate(25 25)" />
        //                 {/* Second countdown circle */}
        //                 {/*<circle id="seconds_circle" fill="none" cx="6.25em" cy="6.25em" r="5em" className="svg-loader_grow" role="progressbar" transform="rotate(-89 100 100) scale(.8, .8) translate(25 25)" filter="url(#glow)" />*/}
        //                 {/* Second countdown text */}
        //                 <text textAnchor="left" x={5-(text.length/3)+"em"} y="4em" fontFamily="'Open Sans', Verdana" fontSize="1.3em">{text}</text>
        //                 <image xlinkHref={NAME_SERVER + "/assets/" + props.color + ".png"} x="3em" y="0.4em" width="6em" height="12em" />
        //                 <text style={{stroke:"white"}} textAnchor="left" x={4.3+"em"} y="6.5em" fontFamily="'Open Sans', Verdana" fontSize="1.3em">{props.name}</text>
        //             </g>
        //         </svg>
        //     </div>
        // </article>
    );
}
export default Winner;